module.exports = __webpack_public_path__ + "static/media/header-foreground-paths-login.fbb2fd11.svg";